import LayoutIndex from '../layout/LayoutIndex'

const newsDetail = {
  path: '/index',
  component: LayoutIndex,
  redirect: '/index',
  name: 'newsDetail',
  meta: {
    name: '资讯'
  },
  children: [
    {
      path: '/newsDetail/:id',
      name: 'newsDetail',
      component: () => import(/* webpackChunkName: "newsDetail" */ '../views/news/detail.vue'),
      meta: {
        name: '资讯详情'
      }
    }
  ]
}
export default newsDetail
